<template>
<div :class="[pageConfigLayoutStyle.ARTICLE_PAGE_WIDE_LAYOUT === pageConfigLayout ? 'article-page-wide':'article-page']">
    <ArticleSummaryList v-if="config && config.LearningList" :bulletPointsString="config.LearningList" :timeEstimate="config.TimeEstimateToRead" :pageLayoutStyle="pageConfigLayout" />
    <div class="widget-container" v-for="(widget, i) in widgets" :key="i">
        <ArticleStyleH1 v-if="widget.Type === 'H1ASpotWidget'" :pageLayoutStyle="pageConfigLayout" :widgetConfig="widget.Model" :articleDetails="config" />
        <ArticleStyleH2 v-else-if="widget.Type === 'H2Widget'" :pageLayoutStyle="pageConfigLayout" :widgetConfig="widget.Model" />
        <ArticleStyleH3 v-else-if="widget.Type === 'H3Widget'" :pageLayoutStyle="pageConfigLayout" :widgetConfig="widget.Model" />
        <ArticleStyleH4 v-else-if="widget.Type === 'H4Widget'" :pageLayoutStyle="pageConfigLayout" :widgetConfig="widget.Model" />
        <ArticlePillButton v-else-if="widget.Type === 'ArticlePillButtonWidget'" :pageLayoutStyle="pageConfigLayout" :widgetConfig="widget.Model" />
        <ArticleStyleImage v-else-if="widget.Type === 'ArticleImageWidget'"  :widgetConfig="widget.Model" />        
        <SubheadImage v-else-if="widget.Type === 'SubheadImageWide'" :widgetConfig="widget.Model" />
        <ArticleSubHead v-else-if="widget.Type === 'SubheadMultilineWide'" :widgetConfig="widget.Model" /> 
        <ArticleMediumHeader v-else-if="widget.Type === 'MediumHeaderWide'" :widgetConfig="widget.Model" />
        <ArticleDetailsBullets  v-else-if="widget.Type === 'SubheadBulletWide'" :widgetConfig="widget.Model" />
        <ArticleMediumHeaderIcons v-else-if="widget.Type === 'MH3ColumnWide'" :widgetConfig="widget.Model"/>
        <MediumHeaderSplitColumn v-else-if="widget.Type === 'MHSplitColumnWide'" :widgetConfig="widget.Model" />
    </div>

    <div class="button-container pt-6">
        <button v-if="config && config.IsVideo" @click="openYouTubeModal()" class="pill-btn blue px-4 full-width-mobile mb-5">Watch video now</button>
        <button @click="navigateToFileClaim" class="pill-btn red filled px-4 full-width-mobile">File a claim</button>
    </div>
</div>
</template>

<script>
import ArticleSummaryList from "@/components/ContentSite/ArticleLayoutComponents/ArticleSummaryList.vue";
import ArticleStyleH1 from "@/components/ContentSite/ArticleLayoutComponents/ArticleStyleH1.vue";
import ArticleStyleH2 from "@/components/ContentSite/ArticleLayoutComponents/ArticleStyleH2.vue";
import ArticleStyleH3 from "@/components/ContentSite/ArticleLayoutComponents/ArticleStyleH3.vue";
import ArticleStyleH4 from "@/components/ContentSite/ArticleLayoutComponents/ArticleStyleH4.vue";
import ArticlePillButton from "@/components/ContentSite/ArticleLayoutComponents/ArticlePillButton.vue";
import ArticleStyleImage from "@/components/ContentSite/ArticleLayoutComponents/ArticleStyleImage.vue";
import SubheadImage from "@/components/ContentSite/ArticleLayoutComponents/SubheadImage.vue";
import ArticleSubHead from "@/components/ContentSite/ArticleLayoutComponents/ArticleSubHead.vue"
import ArticleMediumHeader from "@/components/ContentSite/ArticleLayoutComponents/ArticleMediumHeader.vue";
import ArticleDetailsBullets from "@/components/ContentSite/ArticleLayoutComponents/ArticleDetailsBullets.vue";
import ArticleMediumHeaderIcons from "@/components/ContentSite/ArticleLayoutComponents/ArticleMediumHeaderIcons.vue";
import MediumHeaderSplitColumn from "@/components/ContentSite/ArticleLayoutComponents/MediumHeaderSplitColumn.vue";
import {
    globalEventConsts, pageConfigLayoutStyle
} from "@/constants.js";
import {
    EventBus
} from "@/event-bus.js";
export default {
    name: "ArticlePage",
    props: {
        sequence: Array,
        pageConfigLayout: ""
    },
    components: {
        ArticleSummaryList,
        ArticleStyleH1,
        ArticleStyleH2,
        ArticleStyleH3,
        ArticleStyleH4,
        ArticlePillButton,
        ArticleStyleImage,
        SubheadImage,
        ArticleSubHead,
        ArticleMediumHeader,
        ArticleDetailsBullets,
        ArticleMediumHeaderIcons,
        MediumHeaderSplitColumn
    },
    methods: {
        openYouTubeModal() {
            if (this.config.VideoUrl.trim()) {
                EventBus.$emit(globalEventConsts.SHOW_YOUTUBE_MODAL, this.config.VideoUrl);
            }
        },
        navigateToFileClaim() {
            this.logGAEvent();

            let self = this;
            self.$router.navigate(
                self.navigationScenarioConstants.NAVIGATE_TO_FILE_CLAIM, {}
            );
        },
        logGAEvent() {
            let label = this.authState.idToken != undefined ? "logged_in_yes" : "logged_in_no";
            this.pushEventToGoogleDataLayer("agent_article_page", "file_claim_clicked_footer", label, 0);
        }
    },
    computed: {
        config() {
            return this.sequence?.filter(obj => obj.Type === "ArticleWidget")[0]?.Model;
        },
        widgets() {
            return this.sequence?.filter(obj => obj.Type != "ArticleWidget");
        },
        pageLayoutStyle() {
            return this.widgets[0]?.Model?.LayoutStyle;
        },
        
    }
}
</script>

<style lang="scss" scoped>
.article-page {
    padding-bottom: 40px;
    max-width: $narrower-page-width;
    margin: 0 auto;

    .button-container {
        max-width: $narrower-page-width-padded;
        margin: auto;
        padding: 0 $page-padding;
    }

       &:deep() {
        ul {
            list-style: none;
            @include styled-unordered-list;
        }

        ol {
            li {
                padding: 0 0 $spacer-three $spacer-five;
                position: relative;
                line-height: 25px;
                margin-left: 27px;
            }
        }
     }
    
}
.article-page-wide {
    max-width: $page-width-padded;
    padding-bottom: 40px;
    margin: 0 auto;
    

     .button-container {
        max-width: $page-width-padded;
        margin: auto;
        padding: 0 $page-padding;
     }
     &:deep() {
        ul {
            list-style: none;
            @include styled-unordered-list;
        }

        ol {
            li {
                padding: 0 0 $spacer-three $spacer-five;
                position: relative;
                line-height: 25px;
                margin-left: 27px;
            }
        }
     }
}
</style>
